export interface LogoMarkProps {
  size?: number;
  /** Omit for a decorative mark; pass one where the mark stands alone. */
  title?: string;
}

/** The LendWell mark, drawn in `currentColor` so it follows the theme. */
export function LogoMark({ size = 28, title }: LogoMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 41 40"
      fill="none"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M37.6131 5.41399C37.6131 4.61129 37.2942 3.8415 36.7266 3.27389C36.159 2.70613 35.389 2.38726 34.5863 2.38726C31.9587 2.3877 31.1044 5.99023 28.4767 5.99023L8.9861 5.99023C7.3327 5.99023 5.99242 4.64995 5.99242 2.99655V2.99368C5.99242 1.34027 7.3327 0 8.9861 0L33.7137 0C37.1857 0 40.0005 2.81462 40.0005 6.28682L40.0005 31.016C40.0005 31.8099 39.6851 32.5713 39.1236 33.1328C38.5622 33.6942 37.8007 34.0096 37.0068 34.0096H37.0039C35.3505 34.0096 34.0103 32.6693 34.0103 31.016V11.5254C34.0103 8.89768 37.6128 8.04354 37.6131 5.41586V5.41399ZM2.3873 34.586C2.3873 35.3887 2.70617 36.1585 3.27378 36.7261C3.84139 37.2937 4.61133 37.6126 5.41403 37.6126C8.04171 37.6123 8.896 34.0098 11.5237 34.0098H31.0143C32.6677 34.0098 34.008 35.35 34.008 37.0034V37.0063C34.008 38.6597 32.6677 40 31.0143 40L6.28672 40C2.81466 40 -0.000114441 37.1852 -0.000114441 33.7132L-0.000114441 8.98405C-0.000114441 8.18997 0.315308 7.42851 0.87674 6.86708C1.43817 6.30564 2.19963 5.99023 2.99357 5.99023H2.99644C4.64984 5.99023 5.99012 7.33065 5.99012 8.98405L5.99012 28.4746C5.99012 31.1023 2.38759 31.9565 2.3873 34.5841V34.586Z"
      />
    </svg>
  );
}
